<template>
  <div>
    <div
      class="page_container goodsManageSet"
      v-loading="loading"
      element-loading-text="请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <div class="breadcrumb flex-rowl">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/manage' }"
            >SKU管理</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
            >商品管理</el-breadcrumb-item
          >
          <el-breadcrumb-item
            :to="{
              path: `/commondityIndex/cManageEdit/cAttrLabel`,
            }"
            >属性标签&变量规格式</el-breadcrumb-item
          >
          <el-breadcrumb-item>属性标签&变量规格式设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="form_container">
        <h1>属性标签&变量规格式设置</h1>
        <div class="content_wrap">
          <div class="form_wrap">
            <div class="block">
              <p>属性标签缩略图</p>
              <div
                class="upload_box"
                @mouseenter="creenIndex = 1"
                @mouseleave="creenIndex = ''"
              >
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :http-request="beforeAvatarUpload"
                >
                  <div v-if="formData.pic">
                    <img :src="formData.pic" class="avatar" />
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex == 1"
                    >
                      <span @click.stop="handlePictureCardPreview(formData.pic)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="formData.pic = ''"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>

                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>选择属性标签</p>
              <div class="select_box">
                <el-select
                  v-model="formData.attrid"
                  placeholder="请选择属性标签"
                >
                  <el-option
                    v-for="item in attrList"
                    :key="item.id"
                    :label="item.attrname"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>设置属性标签值</p>
              <div class="input_box">
                <el-input
                  v-model="formData.attrvalue"
                  placeholder="请设置属性标签值"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>设置价格变动值</p>
              <div class="radio_box" style="margin-bottom: 10px">
                <el-radio-group
                  direction="horizontal"
                  v-model="formData.numtype"
                  style="justify-content: space-evenly"
                  @change="handleNumType"
                >
                  <el-radio label="不变" @click="handleClickNumtype('不变')"
                    >不变</el-radio
                  >
                  <el-radio label="增加">增加</el-radio>
                  <!-- <el-radio label="减少">减少</el-radio> -->
                </el-radio-group>
              </div>
              <div
                class="input_box"
                v-if="
                  formData.numtype == '不变' ||
                  formData.numtype == '增加' ||
                  formData.numtype == '减少'
                "
              >
                <el-input
                  v-model="formData.num"
                  :readonly="formData.numtype == '不变' ? true : false"
                  placeholder="请输入价格变动值"
                  maxlength="10"
                  type="digit"
                  @input="handleInput"
                />
              </div>
            </div>

            <div class="block">
              <p><span class="mark">*</span>是否重点标签</p>
              <div class="radio_box">
                <el-radio-group
                  direction="horizontal"
                  v-model="formData.isheavy"
                  style="justify-content: space-evenly"
                >
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否 </el-radio>
                </el-radio-group>
              </div>
            </div>

            <div class="block">
              <p><span class="mark">*</span>属性标签状态</p>
              <div class="radio_box">
                <el-radio-group
                  direction="horizontal"
                  v-model="formData.isuse"
                  style="justify-content: space-evenly"
                >
                  <el-radio :label="true">启用</el-radio>
                  <el-radio :label="false">停用 </el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form_footer flex-rowl">
        <div class="btn" @click="query">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  getAttrLabelList,
  uploadImage,
  editCommondityLabel,
  addCommondityLabel,
  getCommondityLabelDetail,
  encryptstringview,
} from "../../../api/api";
export default {
  name: "cAttrLabelSet",
  data() {
    return {
      loading: false,
      attrList: [], // 属性列表

      id: "", // 属性id
      labelNum: "", // 商品价格
      labeltype: "", // 商品类型
      formData: {
        cmid: "", // 商品id
        attrid: "",
        attrvalue: "",
        numtype: "",
        num: 0,
        pic: "",
        isheavy: false,
        isuse: true,
      },
      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { cmId, id } = JSON.parse(res.jsondata);
        this.formData.cmid = cmId;
        this.id = id;
        if (id) {
          this.getDetail();
        }
        this.getAtrrList();
      } else {
        this.$router.back();
      }
    },

    getDetail() {
      this.loading = true;
      let { id } = this;
      getCommondityLabelDetail({ id }).then((res) => {
        // this.formData = res;
        this.labeltype = res.numtype;
        this.labelNum = res.num;
        this.formData.pic = res.pic ? res.pic : "";
        this.formData.attrid = res.attrid ? res.attrid : "";
        this.formData.attrvalue = res.attrvalue ? res.attrvalue : "";
        this.formData.numtype = res.numtype ? res.numtype : "";
        this.formData.num = res.num ? res.num : 0;
        this.formData.isheavy = res.isheavy ? res.num : false;
        this.formData.isuse = res.isuse ? res.isuse : false;

        this.loading = false;
      });
    },

    // 获取属性标签
    getAtrrList() {
      getAttrLabelList().then((res) => {
        this.attrList = res;
      });
    },
    // 价格变动
    handleNumType(event) {
      let { numtype } = this.formData;
      let { labelNum, labeltype } = this;
      if (event == "不变") {
        this.formData.num = 0;
      } else {
        if (labeltype == numtype && labelNum != "") {
          this.formData.num = labelNum;
        } else if (labeltype == numtype && labelNum != "") {
          this.formData.num = labelNum;
        } else {
          this.formData.num = "";
        }
      }
    },

    handleReturn() {
      history.back();
    },

    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          this.formData.pic = res.url;
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 输入框限制
    handleInput(event) {
      // 只允许输入数字和小数点
      let value = event.replace(/[^\d.]/g, "");
      // 限制只能输入一个小数点
      value = value.replace(/^\./, "").replace(/\.{2,}/g, ".");
      // 截取小数点后两位
      value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.formData.num = value;
    },

    query() {
      let { formData, id } = this;
      // formData.pic = this.imgSplit(formData.pic);
      let params = formData;
      if (formData.attrid == "") {
        this.$message.warning("请选择属性标签");
        return false;
      }
      if (formData.attrvalue == "") {
        this.$message.warning("请填写属性标签值");
        return false;
      }
      if (formData.numtype == "") {
        this.$message.warning("请选择价格变动类型");
        return false;
      }
      if (formData.num == "" && formData.num != 0) {
        this.$message.warning("请填写价格变动值");
        return false;
      }
      this.loading = true;
      if (id) {
        params.id = id;
        editCommondityLabel(params).then((res) => {
          let data = res;
          if (data.result) {
            this.loading = false;
            this.$message.success(data.message);
            // setTimeout(() => {
            //   this.loading = false;
            //   this.$router.back();
            // }, 500);
          } else {
            this.loading = false;
            this.$message.error(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addCommondityLabel(params).then((res) => {
          let data = res;
          if (data.result) {
            this.$message.success(data.message);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },
    // 图片路径的分割
    imgSplit(url) {
      if (url != "" && url) {
        if (url.indexOf("upload")) {
          let splitArr = url.split("/upload/");
          return splitArr[splitArr.length - 1];
        } else if (url.indexOf("Upload")) {
          let splitArr = url.split("/Upload/");
          return splitArr[splitArr.length - 1];
        }
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
}
</style>